import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import {
  toggleNLolayiKeshoyi,
  toggleNAluminiumUpvc,
} from "Constants/Constants";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import MuiButton from "Components/MuiButton/MuiButton";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import { DialogActions } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import {
  getFrameTemplates,
  insertGroupTemplate,
} from "Stores/actions/properties/ShopAction";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";

export default function NewPatternGroup() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [checkValid, setCheckValid] = useState(false);

  const [controls, setControls] = useSetState({
    NameGroup: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    struct: {
      type: "toggle",
      arrayItems: toggleNAluminiumUpvc,
      value: toggleNAluminiumUpvc[0],
      validation: {
        required: true,
      },
    },
    selectType: {
      type: "toggle",
      arrayItems: toggleNLolayiKeshoyi,
      value: toggleNLolayiKeshoyi[0],
      validation: {
        required: true,
      },
    },
    structFrame: {
      type: "select",
      selectItems: [],
      value: null,
    },
  });

  const handleDialog = () => setOpenDialog(!openDialog);

  const onEnter = async () => {
    onClear();
  };

  const onClear = async () => {
    setCheckValid(false);
    setFormValid({ NameGroup: false });
    setControls({ NameGroup: { value: "" } });
    setControls({
      selectType: {
        value: toggleNLolayiKeshoyi[0],
      },
    });
    setControls({ struct: { value: toggleNAluminiumUpvc[0] } });
    await get_FrameTemplates(toggleNLolayiKeshoyi[0].value);
  };

  const get_FrameTemplates = async (type) => {
    setLoading(true);
    const data = await dispatch(
      getFrameTemplates({
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        idType: type === "lolayi" ? 1 : 2,
      })
    );
    setControls({ structFrame: { selectItems: data } });
    setControls({ structFrame: { value: data[0] } });
    setLoading(false);
  };

  const onExit = () => {
    setOpenDialog(false);
  };

  const setValue = async (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const onChangeToggle = async (name, key, value, option = null) => {
    setControls({ [name]: { value: value } });
    if (name === "selectType") get_FrameTemplates(value.value);
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  const onFinish = async (e) => {
    e.preventDefault();
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      const { NameGroup, selectType, struct, structFrame } = controls;
      try {
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Name: NameGroup.value,
          idStruct: struct.value.value === "upvc" ? 1 : 2,
          idType: selectType.value.value === "lolayi" ? 1 : 2,
          idStructFrame: structFrame.value.Id,
        };
        setLoading(true);
        await dispatch(insertGroupTemplate(data));
        onExit();
        setLoading(false);
      } catch (e) {
        showNotify({
          text: t("correctFormDataRequired"),
          customClass: "error",
        });
      }
    } else {
      setCheckValid(true);
    }
  };

  return (
    <>
      <MuiButton
        loading={loading}
        color="primary"
        title={<Translator id={"newPatternGroup"} />}
        onClick={handleDialog}
        fullwidthOnSm
        disabled={!read("settingShopTemplate")?.accessRegister}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        TransitionProps={{ onEnter: onEnter, onExit: onExit }}
        onClose={handleDialog}
        fullWidth
        maxWidth="xs"
      >
        <div>
          <div className="dialogHeader">
            <p>{<Translator id={"newPatternGroup"} />}</p>
          </div>
          <DialogContent id="content-dialog-manager">
            <BackDropLoading loading={loading} />
            <Grid container spacing={2}>
              {Object.keys(controls).map((key, index) => {
                return (
                  <Grid item xs={12} key={key + index}>
                    {controls[key].type === "toggle" && (
                      <MuiRadioGroup
                        name={key}
                        label={<Translator id={key} />}
                        value={controls[key].value}
                        items={controls[key].arrayItems}
                        onChange={onChangeToggle}
                        translate={true}
                        className="horizontalRadio mb-2"
                      />
                    )}
                    {controls[key].type === "select" && (
                      <MuiAutoComplete
                        options={controls[key].selectItems}
                        label={<Translator id={key} />}
                        value={controls[key].value}
                        id={key}
                        onChange={autoCompleteHandler}
                      />
                    )}
                    {controls[key].type === "text" && (
                      <Input
                        setValue={setValue.bind(this)}
                        value={controls[key].value}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type="text"
                        checkValid={checkValid && !formValid[key]}
                      />
                    )}
                  </Grid>
                );
              })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              loading={loading}
              color="primary"
              title={<Translator id="ezafe_be_list" />}
              onClick={onFinish}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
}
